import { useTranslation } from '@thoughtspot/i18n';
import _ from 'lodash';
import React from 'react';

export const NonEmbedAccess: React.FC = () => {
    const { t } = useTranslation();
    return <>{t('NON_EMBED_FULL_APP_ACCESS')}</>;
};
export default NonEmbedAccess;
